<template>
  <!-- eslint-disable -->
  <div class="privacy_policy text-left flex justify-center">
    <div class="privacy_policy__content w-full">
      <h3 class="privacy_policy__title">System monitorowania postępów uczniów</h3>
      <p>Drodzy rodzice, w Early Stage stawiamy ogromny nacisk na radość i przyjemność płynącą z nauki. Wierzymy, że dzięki swojemu  zaangażowaniu  i  motywacji  wewnętrznej  nasi  uczniowie  mogą  w  pełni  rozwijać  swój  potencjał. Pragniemy rozkochać naszych uczniów w nauce języka, dlatego dostrzegamy i doceniamy ich postępy, a błędy traktujemy jako naturalny etap procesu uczenia się.</p>
      <p>Zależy nam, aby nasz szkolny system oceniania wspierał nas w tym zadaniu, dlatego nie stosujemy ocen. Zamiast nich opracowaliśmy autorski system monitorowania postępów uczniów, który objaśniamy poniżej.</p>
      <div class="blue-box bg-blue-light-main p-6 mt-3">
        <h3 class="text-xl font-semibold">
          Kartkówki, testy i egzaminy – wynik podajemy procentowo
        </h3>
        <ul class="pl-5 list__percents">
          <li class="text-lg">
            <span class="font-semibold">80-100%</span> - opanowanie materiału zgodnie z założeniami (a nawet powyżej)!
          </li>
          <li class="text-lg">
            <span class="font-semibold">70-80%</span> - opanowanie większości materiału zgodnie z założeniami, ale dobrze jest cały czas pilnować systematycznej nauki
          </li>
          <li class="text-lg">
            <span class="font-semibold">50-70%</span> - opanowanie dużej ilości zagadnień zgodnie z założeniami; w niektórych obszarach potrzebna jest jednak dalsza praca i wzmożenie wysiłku
          </li>
          <li class="text-lg">
            <span class="font-semibold">50%</span> - konieczność przystąpienia do testu, kartkówki lub egzaminu ponownie
          </li>
        </ul>
      </div>
      <div class="blue-box bg-blue-light-main p-6 mt-6">
        <h3 class="text-xl font-semibold">
          Mówienie i pisanie - oznaczamy za pomocą symboli:
        </h3>
        <ul class="list__symbols">
          <li class="py-3 flex">
            <div class="grade" :style="{
            'background-color': '#7bd6dd',
          }">
              <img class="symbol" src="@/assets/images/grades/symbols/arrow.svg" width="38" />
            </div>
            <span
              class="block pl-3"
            >Dziecko robi wyraźny postęp (nawet jeśli pojawiło się kilka błędów, pamiętajmy, że w procesie uczenia się, popełnianie błędów jest jego częścią).</span>
          </li>
          <li class="py-3 flex">
            <div class="grade" :style="{
            'background-color': '#579acf',
          }">
              <img class="symbol" src="@/assets/images/grades/symbols/refresh.svg" width="38" />
            </div>
            <span
              class="block pl-3"
            >Dziecko robi postępy, jednak, aby jeszcze lepiej potrenować daną umiejętność, zalecamy dalsze ćwiczenia.</span>
          </li>
          <li class="py-3 flex">
            <div class="grade" :style="{
            'background-color': '#ecb4c0',
          }">
              <img class="symbol" src="@/assets/images/grades/symbols/cross.svg" width="38" />
            </div>
            <span
              class="block pl-3"
            >PISANIE: Dziecko nie oddało pracy.<br>MÓWIENIE: Dziecko nie przygotowało się lub nie wzięło udziału w zadaniu na mówienie.</span>
          </li>
        </ul>
      </div>
      <p class="pt-6">Zachęcamy również Państwa do wspierania swoich dzieci w pozytywnym podejściu do nauki. Doceniajmy dzieci za ich zaangażowanie i cieszmy się razem z nimi każdym nowo poznanym słówkiem, piosenką czy historyjką. Jeśli coś Państwa niepokoi, kadra Early Stage jest zawsze do dyspozycji!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MonitorSystemProgress',
};
</script>

<style lang="scss" scoped>
.privacy_policy {
  @apply px-1;
  @media screen and (min-width: 768px) {
    @apply px-4;
  }
  &__title {
    @apply text-center font-bold text-left block mt-4 mb-5;
    font-size: 32px;
    line-height: 36px;
    @media screen and (min-width: 768px) {
      @apply text-center text-4xl;
    }
  }

  &__content {
    @apply leading-normal text-base text-left;
    max-width: 900px;
    margin: auto;
    margin-bottom: 58px;
    @media screen and (min-width: 768px) {
      @apply text-xl;
    }

    h4 {
      @apply font-bold py-5;
    }

    p {
      @apply text-lg py-3;
      line-height: 28px;
      font-weight: 400;
      &:last-child {
        @apply pt-6;
      }
    }

    .blue-box {
      border-radius: 20px;
    }
    .grade {
      @apply flex justify-center items-center rounded;
      width: 38px;
      height: 38px;
      min-width: 38px;
      min-height: 38px;
      .symbol {
        @apply p-2;
      }
    }

    .list {
      &__percents {
        list-style: none;
        padding-left: 0;
        li {
          padding-top: 7px;
          padding-bottom: 7px;
        }
      }
      &__symbols {
        padding-top: 2px;
        li {
          @apply flex text-lg;
          @media screen and (min-width: 768px) {
            @apply items-center;
          }
          &:last-child {
            padding-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
